import { format } from 'date-fns'
import { Text } from 'src/components/ui'
import { TimeRangeOrPeriod, isTimeRange, TimeRange } from 'src/types'

import { LabelValue } from './TimePickerInput'
import { rangeSummary } from './rangeSummary'

type Props = {
  isLive?: boolean
  value: TimeRangeOrPeriod
  options: LabelValue[]
}

const humanDateRange = ({ from, to }: TimeRange): JSX.Element => {
  return (
    <Text className="whitespace-nowrap">
      <span className="font-500">{format(from, 'MMM dd yyyy, ')}</span>
      <span>{format(from, 'HH:mm')} - </span>
      <span className="font-500">{format(to, 'MMM dd yyyy, ')}</span>
      <span>{format(to, 'HH:mm')}</span>
    </Text>
  )
}

export function RangeSummaryLabel({
  isLive,
  value,
  options,
}: Props): JSX.Element {
  const selectLabel = isTimeRange(value) ? (
    isLive ? (
      <Text className="whitespace-nowrap" bold>
        {rangeSummary(value, options).rangeDescription}
      </Text>
    ) : (
      humanDateRange(value)
    )
  ) : (
    <Text bold className="whitespace-nowrap">
      {options.find(option => option.value === value.period)?.label}
    </Text>
  )

  return (
    <div className="flex items-center gap-xs">
      <div
        className={`w-[42px] rounded-2xs px-2xs py-3xs text-center ${
          isLive ? 'bg-background-brand' : 'bg-background-brand-hover'
        }`}
      >
        <Text variant="description">
          {isLive ? 'Live' : rangeSummary(value, options).rangeSummary}
        </Text>
      </div>
      {selectLabel}
    </div>
  )
}
